import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { completeCardId, login } from "../../../util/auth";
import AuthContent from "../AuthContent/AuthContent";
import Logo from "../../../assets/sienna_logo.png";
import Container from "../../../ui/Container/Container";
import "./Login.css";

function Login() {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const authCtxt = useContext(AuthContext);
  const navigate = useNavigate();

  async function loginHandler({ email, password }) {
    setIsAuthenticating(true);
    try {
      const newCardId = completeCardId(password);
      const loginInfo = await login(email, newCardId);
      await authCtxt.authenticate(loginInfo);
      if (loginInfo.role === "Admin") {
        navigate("/initAdmin");
      } else {
        navigate("/init");
      }
      setIsAuthenticating(false);
    } catch (error) {
      alert("No pudiste ingresar. Revisa tus credenciales.");
      setIsAuthenticating(false);
    }
  }

  if (isAuthenticating) {
    return <p>Cargando...</p>;
  }

  return (
    <Container haveHeader={false}>
      <div>
        <div className="imageContainer">
          <img className="image" src={Logo} alt="logo sienna" />
        </div>
      </div>
      <AuthContent onAuthenticate={loginHandler} />
    </Container>
  );
}

export default Login;
